'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsage$002dUser from "./presto.types$-Credential-Usage-User.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsageUser$() {
}
export { $c_Lpresto_types$CredentialUsageUser$ as $c_Lpresto_types$CredentialUsageUser$ };
$p = $c_Lpresto_types$CredentialUsageUser$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsageUser$;
/** @constructor */
function $h_Lpresto_types$CredentialUsageUser$() {
}
export { $h_Lpresto_types$CredentialUsageUser$ as $h_Lpresto_types$CredentialUsageUser$ };
$h_Lpresto_types$CredentialUsageUser$.prototype = $p;
$p.l = (function() {
  return "CredentialUsageUser";
});
$p.cFM = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCredential$002dUsage$002dUser.$c_Lpresto_types$CredentialUsageUser(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$CredentialUsageUser$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsageUser$, "presto.types$CredentialUsageUser$", ({
  Zr: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CredentialUsageUser$ as $d_Lpresto_types$CredentialUsageUser$ };
var $n_Lpresto_types$CredentialUsageUser$;
function $m_Lpresto_types$CredentialUsageUser$() {
  if ((!$n_Lpresto_types$CredentialUsageUser$)) {
    $n_Lpresto_types$CredentialUsageUser$ = new $c_Lpresto_types$CredentialUsageUser$();
  }
  return $n_Lpresto_types$CredentialUsageUser$;
}
export { $m_Lpresto_types$CredentialUsageUser$ as $m_Lpresto_types$CredentialUsageUser$ };
//# sourceMappingURL=presto.types$-Credential-Usage-User$.js.map
